import GoogleLoginComponent from "../googlebutton.component";


export const LoginPage = () => {
    return (
        <div className="loginImage">
            <div className="navbar navbar-light fixed-top order-header-navbar">
                <div className="container-fluid">
                    <div className="navbar-brand logo-text-img" exact aria-current="page" to="/">
                        <img src='./../images/logo.png' alt="" width="40" height="40" className="d-inline-block align-middle" />
                        Community Compassion Center
                    </div>
                </div>

            </div>
            <div className="loginButton">
                <GoogleLoginComponent />

            </div>
        </div>
    );
    return (
        <div className="loginPageOverLay">
            <div className="loginImage">

            </div>
            <div className="loginButton">
                <GoogleLoginComponent />

            </div>

        </div>
    )
}